"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIsFirstRender = useIsFirstRender;

var _react = require("react");

/**
 * SPDX-FileCopyrightText: © 2023 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
function useIsFirstRender() {
  var isFirst = (0, _react.useRef)(true);

  if (isFirst.current) {
    isFirst.current = false;
    return true;
  }

  return isFirst.current;
}